import Api from '@/api/Api'

export default {
  addCorporateRelation (params) {
    return Api().post('Corporate/addCorporateRelation', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/CorporateAPI.js